type PaginationProps = {
  pages: string[];
};

/**
 * 목록 페이지 공용(블로그·뉴스·FAQ·출판물) 가운데 정렬 페이지네이션 — 숫자 최대 5개, 현재 페이지를 가운데 두되
 * 가장자리에선 반대쪽으로 채워 5개를 유지한다(1·끝 앵커·'...' 없음).
 * prev/next 는 항상 포함한다 — 경계에서의 비활성 표시는 렌더 컴포넌트가
 * "현재 페이지가 창의 첫/마지막 숫자인가"로 판별한다(창이 현재를 항상 포함하므로
 * 첫 숫자=현재 ⟺ 1페이지, 마지막 숫자=현재 ⟺ 마지막 페이지).
 */
export const getCenteredPagination = <T>({
  postsPerPage,
  posts,
  current,
}: {
  postsPerPage: number;
  posts: T[];
  current: number;
}): PaginationProps => {
  const endPage = Math.max(1, Math.ceil(posts.length / postsPerPage));
  const start = Math.max(1, Math.min(current - 2, endPage - 4));
  const end = Math.min(endPage, start + 4);

  const pages: string[] = ['prev'];
  for (let i = start; i <= end; i++) {
    pages.push(i.toString());
  }
  pages.push('next');

  return { pages };
};
